
import ItensFactura from "./utente/itensFactura";
import DocumentViewer from "./documentViewer";
import FichaSolicitacaoImportacao from "./fichaSolicitacaoImportacao";
import FichaSolicitacaoDesalfandegamento from "./fichaSolicitacaoDesalfandegamento";
import HeaderGestorConfigs from "../../../../utils/headerGestorConfigs";
import { Card } from "@mui/material";
import DocumentosEmitidos from "./docsEmitidos/documentosEmitidos";


export default function CombineImportacao({ solicitacaoImportacao, setRefresh, habiliteThis, setHabiliteThis }) {

    return (
        <>
            {solicitacaoImportacao?.declaracao &&
                <>
                    <FichaSolicitacaoDesalfandegamento
                        solicitacaoImportacao={solicitacaoImportacao}
                        setRefresh={setRefresh}
                        admin={true}
                        habiliteThis={habiliteThis}
                        setHabiliteThis={setHabiliteThis}
                    />

                    <br />
                    {solicitacaoImportacao?.declaracao?.docs &&
                        <Card style={{ padding: 20 }}>
                            <DocumentViewer pdfUrls={solicitacaoImportacao?.declaracao?.docs} title={'DOCUMENTOS ANEXADOS PARA DESALFANDEGAMENTO'} />
                        </Card>
                    }
                    <br />
                </>
            }

            <FichaSolicitacaoImportacao
                solicitacaoImportacao={solicitacaoImportacao}
                setRefresh={setRefresh} a
                dmin={true}
                habiliteThis={habiliteThis}
                setHabiliteThis={setHabiliteThis}
            />

            <br />
            {solicitacaoImportacao?.docs &&
                <Card style={{ padding: 20 }}>
                    <DocumentViewer pdfUrls={solicitacaoImportacao?.docs} title={'DOCUMENTOS ANEXADOS PARA IMPORTAÇÃO'} />
                </Card>
            }

            <br />
            <Card style={{ padding: 20 }}>
                <HeaderGestorConfigs title={`ITENS ADICIONADOS : ${solicitacaoImportacao?.productos?.length}`} />
                <ItensFactura admin={true} itens={solicitacaoImportacao?.productos} importacaoId={solicitacaoImportacao?._id} solicitacao={solicitacaoImportacao}/>
            </Card>

            {((solicitacaoImportacao?.status === 'Aprovado' || solicitacaoImportacao?.status === 'Não solicitado') && solicitacaoImportacao?.dataAprovacao) &&
            <>
                <br />
                <DocumentosEmitidos solicitacaoImportacao={solicitacaoImportacao} />
            </>
            }
        </>
    )
}
